export class FileUpload {
  FileAsBase64: string;
  FileAsByteArray: string | ArrayBuffer;
}
